import { createReduxAsyncThunk } from 'shared/utils';

import { stationsAPI } from 'entities/stations';

import { STATIONS_STATE } from '../../constants';

import { StationsState } from '../../types';

export const getStations = createReduxAsyncThunk<StationsState['stations']['data']>(
  `${STATIONS_STATE}/getStations`,
  async () => {
    const { data } = await stationsAPI.getStations();
    return data;
  }
);
